import ErrorBoundary from 'components/ErrorBoundary'
import ReactStrapTable from 'components/reactStrapTable'
import React, { useState } from 'react'
import { Card, CardBody, Col, Container, Row } from 'reactstrap'
//import ViewAuditToolTable from '../ViewAuditToolTable'
import Drawer from 'components/Drawer'

const ViewAuditTool = ({ selectedRowView }) => {
    debugger;
    console.log(selectedRowView, 'shubham');

    return (
        <div>
            <Container fluid className='my-3'>
                <Card className='border-0 shadow-top'>
                    <CardBody className='section-devider-border'>
                        <ErrorBoundary>
                            <Row>
                                <h4 className='f-15 text-primary font-weight-700'>Audit Details </h4>
                                <Col md="4">
                                    <p className="m-0 f-14 mt-3">CoveredEntity:</p>
                                    <p className="m-0 f-14 font-weight-500 mt-1">{selectedRowView.coveredEntity}</p>
                                </Col>
                                <Col md="4">
                                    <p className="m-0 f-14 mt-3">Accumulator :</p>
                                    <p className="m-0 f-14 font-weight-500 mt-1">{selectedRowView.accumulator }</p>
                                </Col>
                                <Col md="4">
                                    <p className="m-0 f-14 mt-3">Reason :</p>
                                    <p className="m-0 f-14 font-weight-500 mt-1">{selectedRowView.reason}</p>
                                </Col>
                                <Col md="4">
                                    <p className="m-0 f-14 mt-3">ProviderNPI :</p>
                                    <p className="m-0 f-14 font-weight-500 mt-1">{selectedRowView.providerNPI}</p>

                                </Col>
                                <Col md="4">
                                    <p className="m-0 f-14 mt-3">ProviderName :</p>
                                    <p className="m-0 f-14 font-weight-500 mt-1">{selectedRowView.providerName}</p>

                                </Col>
                                <Col md="4">
                                    <p className="m-0 f-14 mt-3">GrossCharge :</p>
                                    <p className="m-0 f-14 font-weight-500 mt-1">{selectedRowView.grossCharge}</p>

                                </Col>
                                <Col md="4">
                                    <p className="m-0 f-14 mt-3">PrimaryPayor :</p>
                                    <p className="m-0 f-14 font-weight-500 mt-1">{selectedRowView.primaryPayor}</p>

                                </Col>
                                <Col md="4">
                                    <p className="m-0 f-14 mt-3">SecondaryPayor :</p>
                                    <p className="m-0 f-14 font-weight-500 mt-1">{selectedRowView.secondaryPayor}</p>

                                </Col>
                                <Col md="4">
                                    <p className="m-0 f-14 mt-3">TertiaryPayor :</p>
                                    <p className="m-0 f-14 font-weight-500 mt-1">{selectedRowView.tertiaryPayor}</p>

                                </Col>
                                <Col md="4">
                                    <p className="m-0 f-14 mt-3">Facility :</p>
                                    <p className="m-0 f-14 font-weight-500 mt-1">{selectedRowView.facility}</p>

                                </Col>
                                <Col md="4">
                                    <p className="m-0 f-14 mt-3">HCPCS :</p>
                                    <p className="m-0 f-14 font-weight-500 mt-1">{selectedRowView.hcpcs}</p>

                                </Col>
                                <Col md="4">
                                    <p className="m-0 f-14 mt-3">TransactionID :</p>
                                    <p className="m-0 f-14 font-weight-500 mt-1">{selectedRowView.transactionID}</p>

                                </Col>
                                <Col md="4">
                                    <p className="m-0 f-14 mt-3">Comment :</p>
                                    <p className="m-0 f-14 font-weight-500 mt-1">{selectedRowView.comment}</p>

                                </Col>
                            </Row>
                        </ErrorBoundary>
                    </CardBody>
                </Card>
            </Container>
        </div>
    );
};
export default ViewAuditTool